import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {BrickSnake2000} from "../BrickSnake2000";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class BrickSnake2000DoubleOrNothingWinPresentation implements FlowStatePresentation {

    constructor() {}

    // needed to figure out what the keypad should say since we cant figure out we came from base game or freespins
    public static wasTotalWin:boolean = false;

    public start(flowStateController:FlowStateController) {
        flowStateController.setSkipCallback(undefined);


        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(()=> {
            BrickSnake2000.keypadPlugin.setWin(BrickSnake2000.model.data.accumulatedRoundWin,
                                               BrickSnake2000DoubleOrNothingWinPresentation.wasTotalWin,
                                               BrickSnake2000.isWinBelowStake());
        })

        const gambled =  BrickSnake2000.model.gameData.totalSpinWinnings != 0;
        const didWin = BrickSnake2000.model.data.accumulatedRoundWin == 0 ;

        if (gambled) {
            tl.add(() => {BrickSnake2000.soundPlayer.stopSound("winCapLoop")});
            tl.add(didWin
                   ? [BrickSnake2000.transitionScreen.showMaxWinZero(),
                      () => {BrickSnake2000.soundPlayer.playLoopingSound("maxWinDoubleNoWinLoop")}]
                   : [BrickSnake2000.transitionScreen.showMaxWinDouble(),
                      () => {BrickSnake2000.soundPlayer.playLoopingSound("maxWinDoubleWinLoop")}]);
        }
        if (gambled)
            tl.add(BrickSnake2000.transitionScreen.enableButton(() => this.done(flowStateController)), '>2');
        else
            tl.add(() => this.done(flowStateController));
    }

    private done(flowStateController:FlowStateController):void {
        const tl = gsap.timeline();
        tl.add(() => {
            BrickSnake2000.soundPlayer.switchMusic(GameMode.NORMAL)
            BrickSnake2000.soundPlayer.fadeInMusic();
            BrickSnake2000.soundPlayer.stopSound("maxWinDoubleWinLoop");
            BrickSnake2000.soundPlayer.stopSound("maxWinDoubleNoWinLoop");
            BrickSnake2000.soundPlayer.stopSound("winCapLoop");
            BrickSnake2000.freespinsReelView.disable();
            BrickSnake2000.baseGameReelView.enable();
            BrickSnake2000.baseGameReelView.getAllSymbolsActually().forEach((sym) => sym.alpha = 1);
        });
        tl.add(BrickSnake2000.backgroundElements.setToBaseGame(), '<');
        tl.add(BrickSnake2000.transitionScreen.hideMaxWin(), '<');
        tl.add(() => flowStateController.finish());
    }
}